<rt-button (click)="expand.emit()" variant="plain"> {{ text }} </rt-button>

<rt-divider></rt-divider>
